export default {
  availabilityGallery: (state) => state.availabilityGallery,
  availabilityGallerySvgData: (state) => state.availabilityGallerySvgData,
  selectedPaymentMethodId: (state) => state.selectedPaymentMethodId,
  priceTags: (state) => state.priceTags,
}
